import Link from 'next/link'

const NewsRow = ({ newsList }) =>
  newsList.map((news, idx) => {
    const newsOne = news[0]
    const newsTwo = news[1]
    return (
      <div key={idx} className="grid lg:grid-cols-3 mt-8 h-auto min-h-[600px]">
        {idx % 2 === 0 ? (
          <>
            <Link
              href={newsOne.ctaLink}
              className="relative grid w-full pt-10 pb-24 lg:py-16 text-left px-4 sm:px-8 lg:px-16 bg-sec-grey-4 hover:bg-accent mr-8"
            >
              <h1 className="text-4xl font-alliance-medium tracking-tight text-blue lg:text-4xl xl:text-5xl lg:mr-24">
                <span className="block xl:inline">{newsOne.title}</span>
              </h1>
              <div className="absolute bottom-0 right-0">
                <img
                  src={`/assets/icons/arrow-circle-right.svg`}
                  alt="icon"
                  className="w-10 lg:w-12 m-8"
                />
              </div>
            </Link>
            <div className="h-[400px] table-row lg:h-full">
              <div
                className={`h-full block bg-cover ${
                  newsOne.position ? `bg-${newsOne.position}` : ''
                }`}
                style={{
                  backgroundImage: `url(
                    ${newsOne.img}
                  )`
                }}
              ></div>
            </div>
            {newsTwo && (
              <div className="table lg:ml-8 mt-8 lg:mt-0">
                <div className="relative w-full pt-10 pb-24 lg:py-16 text-left px-4 sm:px-8 bg-sec-grey-4 hover:bg-accent">
                  <Link href={newsTwo.ctaLink}>
                    <h1 className="text-4xl font-alliance-medium tracking-tight text-blue lg:text-3xl xl:text-4xl lg:mr-24">
                      <span className="block xl:inline">{newsTwo.title}</span>
                    </h1>
                  </Link>
                  <div className="absolute bottom-0 right-0">
                    <img
                      src={`/assets/icons/arrow-circle-right.svg`}
                      alt="icon"
                      className="w-10 lg:w-12 m-8"
                    />
                  </div>
                </div>
                <div className="h-[400px] lg:table-row lg:max-h-[300px] lg:h-full">
                  <div
                    className={`h-full lg:table-cell bg-cover ${
                      newsTwo.position ? `bg-${newsTwo.position}` : ''
                    }`}
                    style={{
                      backgroundImage: `url(
                    ${newsTwo.img}
                  )`
                    }}
                  />
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <div className="table lg:ml-8 mt-8 lg:mt-0">
              <div className="relative w-full pt-10 pb-24 lg:py-16 text-left px-4 sm:px-8 bg-sec-grey-4 hover:bg-accent">
                <Link href={newsOne.ctaLink}>
                  <h1 className="text-4xl font-alliance-medium tracking-tight text-blue lg:text-3xl xl:text-4xl lg:mr-24">
                    <span className="block xl:inline">{newsOne.title}</span>
                  </h1>
                  <div className="absolute bottom-0 right-0">
                    <img
                      src={`/assets/icons/arrow-circle-right.svg`}
                      alt="icon"
                      className="w-10 lg:w-12 m-8"
                    />
                  </div>
                </Link>
              </div>
              <div className="h-[400px] lg:table-row lg:max-h-[300px] lg:h-full">
                <div
                  className={`h-full lg:table-cell bg-cover ${
                    newsOne.position ? `bg-${newsOne.position}` : ''
                  }`}
                  style={{
                    backgroundImage: `url(
                  ${newsOne.img}
                )`
                  }}
                />
              </div>
            </div>
            {newsTwo && (
              <>
                <Link
                  href={newsTwo.ctaLink}
                  className="relative grid w-full pt-10 pb-24 lg:py-16 text-left px-4 sm:px-8 lg:px-16 bg-sec-grey-4 hover:bg-accent lg:ml-8"
                >
                  <h1 className="text-4xl font-alliance-medium tracking-tight text-blue lg:text-4xl xl:text-5xl lg:mr-24">
                    <span className="block xl:inline">{newsTwo.title}</span>
                  </h1>
                  <div className="absolute bottom-0 right-0">
                    <img
                      src={`/assets/icons/arrow-circle-right.svg`}
                      alt="icon"
                      className="w-10 lg:w-12 m-8"
                    />
                  </div>
                </Link>
                <div className="h-[400px] table-row lg:h-full">
                  <div
                    className={`h-full block bg-cover ${
                      newsTwo.position ? `bg-${newsTwo.position}` : ''
                    }`}
                    style={{
                      backgroundImage: `url(
                  ${newsTwo.img}
                )`
                    }}
                  ></div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    )
  })

export default NewsRow
